import { render, staticRenderFns } from "./DiscountInformation.vue?vue&type=template&id=d4a1d110"
import script from "./DiscountInformation.vue?vue&type=script&lang=ts"
export * from "./DiscountInformation.vue?vue&type=script&lang=ts"
import style0 from "./DiscountInformation.vue?vue&type=style&index=0&id=d4a1d110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports